import React from 'react';
import { Link, graphql } from 'gatsby';
import SEO from '../components/SEO';
import Helmet from 'react-helmet';
import Layout from '../layouts/index';
import Share from '../components/Share';
// import { Link } from 'gatsby';
import LatestBlogPosts from '../components/LatestBlogPosts.js';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import Subscribe from '../components/Subscribe';
import HtmlParser from 'html-react-parser';
const _ = require('lodash');

const Page = ({ data, location }) => {
  const { title } = data.markdownRemark.frontmatter;
  // const { subtitle } = data.markdownRemark.frontmatter;
  const { categories } = data.markdownRemark.frontmatter;
  const { seotitle } = data.markdownRemark.frontmatter.seo;
  const { date } = data.markdownRemark.frontmatter;
  const { description } = data.markdownRemark.frontmatter;
  const { pageclass } = data.markdownRemark.frontmatter;
  const { heroimage } = data.markdownRemark.frontmatter;
  const { author } = data.markdownRemark.frontmatter;
  const { authortitle } = data.markdownRemark.frontmatter;
  const { authorimage } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;
  // const { tags } = data.markdownRemark.frontmatter;
  const { twitterHandle } = data.site.siteMetadata;
  //const { url } = data.site.siteMetadata;
  const { path } = data.markdownRemark.frontmatter;
  const { metaimg } = data.markdownRemark.frontmatter.seo;
  const { description_fb } = data.markdownRemark.frontmatter.seo;
  const { description_twitter } = data.markdownRemark.frontmatter.seo;
  const { title_fb } = data.markdownRemark.frontmatter.seo;
  const { title_twitter } = data.markdownRemark.frontmatter.seo;
  const pagepath = location.pathname;
  const sharetitle = title_twitter ? title_twitter : title;
  const shareurl = `https://www.charthop.com${location.pathname}`;
  const metaimgurl = `https://www.charthop.com${metaimg}`;
  const metadefaultimgurl = `https://www.charthop.com/blog/Bunny@2x.jpg`;

  const categoryClass = categories.toString();

  function conditionalAuthorTitle(authortitle) {
    let result;
    if (authortitle === "") {
      result = ""
    } else {
      result = authortitle;
    }
    return result;
  }

  const categoryPath = `/blog/${_.kebabCase(categories)}/`;
  let urlArray = pagepath.split('/');
  let urlTitle = urlArray && urlArray[urlArray.length-2];

  return (
    <Layout  context="blog" bodyClass={pageclass}>
      <SEO title={seotitle} />
      <Helmet>
        <meta name="description" content={description} />

        <meta property="og:url" content={shareurl} />
        <meta property="og:title" content={title_fb ? title_fb : title} />
        <meta property="og:description" content={description_fb ? description_fb : description} />
        <meta property="og:image" content={metaimg ? metaimgurl : metadefaultimgurl} />
        <meta property="og:type" content="website" />
        <meta name="author" content={author} />
        
        {/* Twitter Card tags */}
        <meta name="twitter:title" content={title_twitter ? title_twitter : title} />
        <meta name="twitter:description" content={description_twitter ? description_twitter : description} />
        <meta name="twitter:image" content={metaimg ? metaimgurl : metadefaultimgurl} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* POST TITLES */}
      <section className="sectionSpacing pb-1">
        <div className="d-flex flex-column contentBlock">
          <div className="blogCopy">
            <a target="_blank" href={"https://www.charthop.com" + categoryPath} className="blogTaxonomy m-0 categoryLink">{categories}</a>
            <h1 className="pt-1">{title}</h1>
            <div className="subTitleData d-flex pt-1 pb-2">
              <div className="blogAuthorTag">
                <img src={authorimage} alt="Blog Author" />
                <div className="d-flex flex-column">
                  <p className="my-0">by <b>{author}</b></p>
                  <p className="my-0">{date}</p>
                </div>
              </div>

              <div className="d-flex align-items-center">
                
                <p className="m-0 mr-1">Share:</p>
                <Share
                  socialConfig={{
                    twitterHandle,
                    config: {
                      url: `${shareurl}`,
                      sharetitle
                    },
                  }}
                />
              </div>

            </div>
            <hr className="mt-0"></hr>
            
          </div>

        </div>

      </section>

      {/* POST IMAGE */}
      <section className="sectionSpacing py-1">
        <div className="d-flex flex-column ">
          <img className="imageBoxShaddow fullSegmentImage mx-auto" src={heroimage} alt="The ChartHop Team" />
        </div>
      </section>

      {/* POST CONTENT */}
      <section className="sectionSpacing blogPostContent">
        <div className="d-flex flex-column pt-0 blogCopy contentBlock">
          <div className="content" dangerouslySetInnerHTML={{ __html: html }}></div>
        </div>
        <section className="blogCopy sectionSpacing px-0 pb-0">
          <hr className="mt-0"></hr>

          <div className="d-flex align-items-center justify-content-center">
            <p className="m-0 mr-1">Share:</p>
            <Share
              socialConfig={{
                twitterHandle,
                config: {
                  url: `${shareurl}`,
                  sharetitle
                },
              }}
            //tags={tags}
            />
          </div>
          <hr className="mb-0"></hr>

        </section>
      </section>


      {/* AUTHOR DETAILS */}
      <section className="sectionSpacing pt-0 authorBookend">
        <div className="mb-0">
          <img src={authorimage} alt="Blog Author" />
          <p>Written by <b>{author}</b></p>
          <p>{conditionalAuthorTitle(authortitle)}</p> 
        </div>
      </section>

      <Subscribe />

      {/* MORE CARDS */}
      <LatestBlogPosts category={categoryClass} excludePath={path} sectionClass="backgroundGradientContainer-Reverse" ctaLink={categoryPath}/>    

      {/* LONG FORM */}
      <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
        <DemoFormLong source={`blog-${urlTitle || title}-demo-bottom`} headertext={HtmlParser("<h1>See it in action!</br></br> Request a demo now.</h1>")} focusID={HtmlParser("name")} />
      </section>
    </Layout>
  );
};

export const query = graphql`
query($id: String!, $category: String) {
  markdownRemark(id: { eq: $id }) {
    frontmatter {
      title
      categories
      path
      date(formatString: "MMMM Do, YYYY")
      pageclass
      heroimage
      author
      authortitle
      authorimage
      description
      seo{
        seotitle
        metaimg
        title_fb
        description_fb
        title_twitter
        description_twitter
      }
    }
    id
    html
  }
  site {
    siteMetadata {
      twitterHandle
      url
    }
  }
  allMarkdownRemark(
    limit: 3
    sort: { fields: [frontmatter___date], order: DESC }
    filter: { frontmatter: { categories: { in: [$category] } } }
  ) {
    totalCount
    edges {
      node {
        frontmatter {
          title
          path
        }
      }
    }
  }
}
`;

export default Page;
